"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var Study = function (_a) {
    var type = _a.type, width = _a.width, height = _a.height, fill = _a.fill;
    switch (type) {
        case 'line':
        default:
            return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9091 8.18183H29.0909V30.5303C29.0909 31.2416 28.287 31.8182 27.5757 31.8182H16.8939H11.7424H7.27272V35.4545H11.7424H28.4848C31.3299 35.4545 32.7273 33.1481 32.7273 30.303V8.4091V4.54547H29.7727H11.7424H7.27272V8.4091V12.2727H10.9091V8.18183ZM11.8182 19.9998V27.7271L8.18181 27.727V19.9997L11.8182 19.9998ZM2.72726 16.3635L15.4545 16.3637V19.9998L6.47382 19.9997C4.40466 19.9997 2.72726 18.4971 2.72726 16.3635Z", fill: fill })));
    }
};
Study.propTypes = {
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
Study.defaultProps = {
    type: 'solid',
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = Study;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3R1ZHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaWNvbnMvU3R1ZHkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNkJBQStCO0FBQy9CLHNDQUF3QztBQUV4QyxvQ0FBZ0M7QUFRaEMsSUFBTSxLQUFLLEdBQXlCLFVBQUMsRUFBMkI7UUFBMUIsY0FBSSxFQUFFLGdCQUFLLEVBQUUsa0JBQU0sRUFBRSxjQUFJO0lBQzdELFFBQVEsSUFBSSxFQUFFO1FBQ1osS0FBSyxNQUFNLENBQUM7UUFDWjtZQUNFLE9BQU8sQ0FDTCw2QkFBSyxLQUFLLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFDLFdBQVcsRUFBQyxJQUFJLEVBQUMsTUFBTTtnQkFDaEUsOEJBQ0UsUUFBUSxFQUFDLFNBQVMsRUFDbEIsUUFBUSxFQUFDLFNBQVMsRUFDbEIsQ0FBQyxFQUFDLGdhQUFnYSxFQUNsYSxJQUFJLEVBQUUsSUFBSSxHQUNWLENBQ0UsQ0FDUCxDQUFDO0tBQ0w7QUFDSCxDQUFDLENBQUM7QUFFRixLQUFLLENBQUMsU0FBUyxHQUFHO0lBQ2hCLElBQUksRUFBRSxTQUFTLENBQUMsTUFBYTtJQUM3QixLQUFLLEVBQUUsU0FBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFRO0lBQ3ZFLE1BQU0sRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDeEUsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFNO0NBQ3ZCLENBQUM7QUFFRixLQUFLLENBQUMsWUFBWSxHQUFHO0lBQ25CLElBQUksRUFBRSxPQUFPO0lBQ2IsS0FBSyxFQUFFLEVBQUU7SUFDVCxNQUFNLEVBQUUsRUFBRTtJQUNWLElBQUksRUFBRSxjQUFLO0NBQ1osQ0FBQztBQUVGLGtCQUFlLEtBQUssQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Study.js
// module id = 98
// module chunks = 0